module.exports = __webpack_public_path__ + "media/images/athletes/3593-bcdfb62a5b2d4960b60deff6a7d196f0.png";